<template>
    <div v-html="row.display_content">
    </div>
</template>


<script>

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        },

    }
</script>